module.exports = __webpack_public_path__ + "static/media/icon-5-white.4ff79d3d.png";